// extracted by mini-css-extract-plugin
module.exports = {"Feedback":"Feedback_Feedback__1Fn0J"};